<template>
    <v-row>
        <v-col cols="12" class="text-body-2 d-flex justify-space-between align-center">
            Factures
        </v-col>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            class="elevation-1"
            hide-default-header
            hide-default-footer
            @click:row="handleClick"
            dense
        >
          <template v-slot:item.statusId="{item}">
            <v-chip small outlined :color="statusColor(item.statusId)" dark>
              {{ item.statusId}}
            </v-chip>
          </template>

          <template v-slot:item.amount="{item}">
            {{ item.amount | currency(item.currency)}}
          </template>

        </v-data-table>
      </v-col>
    </v-row>
</template>

<script>
export default {
  data: () => {
    return {
      headers: [
        {
          text: 'invoiceNumber',
          value: 'invoiceNumber',
        },
        {
          text: 'statusId',
          value: 'statusId',
        },
        {
          text: 'client',
          value: 'order.client.displayName',
        },
        {
          text: 'orderId',
          value: 'orderId',
        },
        {
          text: 'amount',
          value: 'amount',
        },
      ]
    }
  },
    props:{
        items:{
            type: Array,
            required:true
        },
        type: {
            type: String,
            default: () => 'all'
        }
    },
    methods:{
        open(id){
            this.$router.push('/orders/view/'+id);
            this.$emit('close')
        },
      handleClick(item) {
        this.open(item.orderId)
      },
      statusColor(status){

        const colors = {
          new: 'default',
          open: 'warning',
          paid: 'success',
          cancel: 'error'
        }

        return colors[status] || 'default'

      }
    }
}
</script>